import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  noWrap: {
    whiteSpace: 'nowrap',
  },
  textLabel: {
    maxWidth: '300px',
  },
}));

export default useStyles;
